import { FreeTextAmpLabel } from "./KitModel";
import { EditableOrganism } from "./ProbeSetForm";
var KitSerializer = /** @class */ (function () {
    function KitSerializer() {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setAmplifier = function (state) {
            _this.amplifierState = state;
        };
        this.setBuffers = function (state) {
            _this.buffersState = state;
        };
        this.serializeKit = function (comment, legacy, sampleType) {
            var probeSetComponent = null;
            var negativeControlProbe = false;
            if (_this.probeSetState) {
                var scaleValue = _this.probeSetState.scale.scaleValue;
                negativeControlProbe = _this.probeSetState.negativeControlProbe;
                probeSetComponent = {
                    _type: 'manual',
                    probeSet: KitSerializer
                        .serializeProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                    scaleValue: scaleValue,
                    channel: 1
                };
            }
            var amplifierComponent = null;
            if (_this.amplifierState) {
                amplifierComponent = KitSerializer.serializeAmplifier(_this.amplifierState);
            }
            var buffersComponent = null;
            if (_this.buffersState) {
                buffersComponent = KitSerializer.serializeBuffers(legacy, _this.buffersState);
            }
            return {
                '_type': 'rna-fish',
                kit: {
                    legacy: legacy,
                    sampleTypeId: sampleType.id,
                    amplifierComponent: amplifierComponent,
                    buffersComponent: buffersComponent,
                    probeSetComponent: probeSetComponent,
                    comment: comment,
                    negativeControlProbe: negativeControlProbe,
                    starterKit: false,
                    priceModes: {
                        probeSetMode: serializePriceMode(_this.probeSetState ? _this.probeSetState.customPrice : undefined),
                        amplifierMode: serializePriceMode(_this.amplifierState ? _this.amplifierState.customPrice : undefined),
                        buffersMode: serializePriceMode(_this.buffersState ? _this.buffersState.customPrice : undefined),
                    }
                }
            };
        };
    }
    KitSerializer.serializeProbeSet = function (organism, target, hcrAmplifier, probeLotNumber) {
        var jsonTarget = {
            name: target.name.trim(),
            accession: target.accession.trim(),
            targetMrnaSeq: target.targetMrnaSeq
        };
        if (target.variantId != null) {
            return {
                '_type': 'catalog',
                id: target.variantId,
                hcrAmplifier: hcrAmplifier.id,
                probeLotNumber: probeLotNumber ? probeLotNumber : "",
                customerOrganismName: organism.displayName(),
                customerTargetName: target.serializationName(),
                customerAccessionNum: target.accession,
                customerSequence: target.targetMrnaSeq,
                customerProbeSetSize: target.probeSetSize
            };
        }
        else if (organism.id !== EditableOrganism.default().id) {
            return {
                '_type': 'libraryOrganismCustomTarget',
                organism: {
                    id: organism.id,
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber ? probeLotNumber : ""
            };
        }
        else {
            return {
                '_type': 'otherOrganismCustomTarget',
                organism: {
                    name: organism.name.trim()
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber ? probeLotNumber : ""
            };
        }
    };
    KitSerializer.serializeAmplifier = function (a) {
        var label;
        if (a.label instanceof FreeTextAmpLabel) {
            label = {
                '_type': 'free-text',
                name: a.label.name
            };
        }
        else {
            label = {
                '_type': 'predefined',
                id: a.label.id
            };
        }
        return {
            _type: 'manual',
            scalePmol: a.scale.valuePmol,
            label: label,
            hcrAmplifier: a.hcrAmplifier.id
        };
    };
    KitSerializer.serializeBuffers = function (legacy, b) {
        return {
            _type: 'manual',
            "hybridizationBufferMl": b.hybridization.valueMl,
            "probeWashBufferMl": legacy ? b.probeWash.valueMl : b.goldProbeWash.valueMl,
            'ampBufferMl': b.amp.valueMl,
            'ampWashBufferMl': b.ampWash.valueMl,
        };
    };
    return KitSerializer;
}());
export default KitSerializer;
/**
 * @param m undefined for price list prices, CustomComponentPrice for custom prices
 */
export var serializePriceMode = function (m) {
    if (m === undefined) {
        return { _type: 'priceList' };
    }
    return {
        _type: 'custom',
        effectivePriceCents: m.effectivePriceCents,
        listPriceCents: m.listPriceCents
    };
};
//# sourceMappingURL=KitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/KitSerializer.js
// module id = 103
// module chunks = 0